var _path, _path2, _path3, _path4, _g, _g2, _g3, _g4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPicture(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 51,
    viewBox: "0 0 106 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M26.6159 42.9472C35.4012 43.5915 38.3769 38.079 52.1926 40.7994C63.2451 42.9472 68.1337 36.146 69.6216 31.8506C70.3301 29.7745 70.6843 21.7563 64.5912 21.47C43.974 20.5393 27.8912 -0.794735 17.5472 17.1745C13.367 24.4768 6.63633 41.4437 26.6159 42.9472Z",
    fill: "#8258F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4829 25.4113H64.2419",
    stroke: "#32CDFB",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4829 25.4113L65.4781 42.1235",
    stroke: "#32CDFB",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4781 9.33517L41.4829 26.0474",
    stroke: "#32CDFB",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7_7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.8151 20.3719L6.49707 20.4304C5.11798 20.4328 4.00195 21.5587 4.00436 22.9451L4.01544 29.3286C4.01785 30.715 5.13777 31.837 6.51687 31.8345L39.8349 31.7761C41.214 31.7737 42.33 30.6478 42.3276 29.2613L42.3165 22.8779C42.3141 21.4915 41.1942 20.3695 39.8151 20.3719Z",
    fill: "#32CDFB"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_7_7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.8151 20.0044L65.4971 20.0628C64.118 20.0653 63.002 21.1912 63.0044 22.5776L63.0154 28.961C63.0178 30.3475 64.1378 31.4694 65.5169 31.467L98.8349 31.4086C100.214 31.4061 101.33 30.2803 101.328 28.8938L101.317 22.5104C101.314 21.1239 100.194 20.002 98.8151 20.0044Z",
    fill: "#32CDFB"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_7_7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.8414 35.4027L65.5233 35.4611C64.1442 35.4636 63.0282 36.5894 63.0306 37.9759L63.0417 44.3593C63.0441 45.7458 64.164 46.8677 65.5431 46.8653L98.8612 46.8068C100.24 46.8044 101.356 45.6785 101.354 44.2921L101.343 37.9086C101.34 36.5222 100.22 35.4003 98.8414 35.4027Z",
    fill: "#32CDFB"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_7_7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.4866 4.29858L65.1685 4.35704C63.7894 4.35946 62.6734 5.48534 62.6758 6.87177L62.6869 13.2552C62.6893 14.6417 63.8092 15.7636 65.1883 15.7612L98.5064 15.7027C99.8855 15.7003 101.001 14.5744 100.999 13.188L100.988 6.80455C100.986 5.41812 99.8657 4.29616 98.4866 4.29858Z",
    fill: "#32CDFB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7_7",
    x: 0.00435638,
    y: 16.3719,
    width: 46.3232,
    height: 19.4626,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7_7"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7_7",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_7_7",
    x: 59.0043,
    y: 16.0044,
    width: 46.3233,
    height: 19.4626,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7_7"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7_7",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_7_7",
    x: 59.0306,
    y: 31.4027,
    width: 46.3233,
    height: 19.4626,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7_7"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7_7",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_7_7",
    x: 58.6758,
    y: 0.298584,
    width: 46.3233,
    height: 19.4626,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7_7"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7_7",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPicture);
export default __webpack_public_path__ + "static/media/picture.91888b487974e546d26dcd10ef2f85de.svg";
export { ForwardRef as ReactComponent };